import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from 'src/redux/store';
import { PaginationModel } from 'src/utils/types';

export interface HistoryPaginationState {
    paginationModel: PaginationModel;
}

const initialState: HistoryPaginationState = {
    paginationModel: {
        pageSize: 5,
        page: 0,
    },
};

const historySlice = createSlice({
    name: 'history',
    initialState,
    reducers: {
        setPaginationModel: (state, action: PayloadAction<PaginationModel>) => {
            state.paginationModel = action.payload;
        },
        resetPaginationModel: (state) => {
            state.paginationModel = initialState.paginationModel;
        },
    },
});
export const historyActions = { ...historySlice.actions };
export default historySlice.reducer;
export const historySelectors = {
    paginationModel: (state: RootState) => state.history.paginationModel,
};
